import {
  ContextualMenu,
  Modal,
  PrimaryButton,
  Stack,
  Text
} from '@fluentui/react';
import { CloseButton } from 'common/components/Buttons';
import React, { useState } from 'react';
import { AddGroupModal } from './AddGroupModal';
import { TestGroupsSelector } from './TestGroupSelector';
import { useStyles } from './index.styles';

export const TestGroupsModal: React.FC<{
  onClose: () => void;
  onGroupSelect: (selectedGroupId: string | undefined) => void;
}> = (props) => {
  const styles = useStyles();
  const [selectedKey, setSelectedKey] = useState<string | undefined>(undefined);
  return (
    <Modal
      isOpen
      containerClassName={styles.modalContainer}
      scrollableContentClassName={styles.noScrollContainer}
      dragOptions={{
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu,
        dragHandleSelector: '.ms-Modal-scrollableContent > div:first-child',
      }}
    >
      <Stack tokens={{ padding: 20, childrenGap: 30 }}>
        <Stack
          horizontal
          verticalAlign="center"
          tokens={{ childrenGap: 30 }}
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            width: '100%',
          }}
        >
          <Text variant="xLarge">Test Groups</Text>
          <AddGroupModal isEdit={false} />
          <Stack style={{ position: 'absolute', right: 30 }}>
            <CloseButton onClick={() => props.onClose()} />
          </Stack>
        </Stack>
        <Stack
          style={{
            position: 'absolute',
            top: 50,
            bottom: 80,
            overflow: 'auto',
            width: `calc(100% - 30px)`,
          }}
        >
          <TestGroupsSelector onChange={(value) => setSelectedKey(value)} />
        </Stack>
        <Stack
          horizontal
          horizontalAlign="end"
          tokens={{ childrenGap: 10 }}
          style={{ position: 'absolute', bottom: 20, right: 30 }}
        >
          <PrimaryButton
            text="Select"
            onClick={() => {
              props.onGroupSelect(selectedKey || undefined);
              props.onClose();
            }}
            disabled={!selectedKey}
          />
        </Stack>
      </Stack>
    </Modal>
  );
};
